export const en = {};